import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
    title: string;
    description: string;
    schema?: object; // JSON-LD schema
}

const SEO: React.FC<SEOProps> = ({ title, description, schema }) => {
    const location = useLocation();

    useEffect(() => {
        // Update Title
        document.title = title;

        // Update Meta Description
        let metaDescription = document.querySelector('meta[name="description"]');
        if (!metaDescription) {
            metaDescription = document.createElement('meta');
            metaDescription.setAttribute('name', 'description');
            document.head.appendChild(metaDescription);
        }
        metaDescription.setAttribute('content', description);

        // Update Open Graph tags for better sharing
        const setOgTag = (property: string, content: string) => {
            let tag = document.querySelector(`meta[property="${property}"]`);
            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute('property', property);
                document.head.appendChild(tag);
            }
            tag.setAttribute('content', content);
        };

        setOgTag('og:title', title);
        setOgTag('og:description', description);
        setOgTag('og:url', window.location.href);

        // Add JSON-LD Schema if provided
        let scriptTag = document.querySelector('script[type="application/ld+json"]');
        if (schema) {
            if (!scriptTag) {
                scriptTag = document.createElement('script');
                scriptTag.setAttribute('type', 'application/ld+json');
                document.head.appendChild(scriptTag);
            }
            scriptTag.textContent = JSON.stringify(schema);
        } else if (scriptTag) {
            // Remove schema if not provided for this page to avoid caching wrong schema
            scriptTag.remove();
        }

    }, [title, description, schema, location]);

    return null;
};

export default SEO;
